import * as React from 'react';
import Home from '@/pages/Home';
import Buttons from '@/pages/Buttons';
import Login from '@/pages/Login';
import Logout from '@/pages/Logout';
import NotFound from '@/pages/NotFound';
import QrScanner from '@/pages/QrScanner';
import Qr from '@/pages/Qr';
import LoginLite from '@/pages/LoginLite';

export default [
  {
    path: '/',
    exact: true,
    element: <Home />,
  },
  {
    path: 'buttons',
    element: <Buttons />,
  },
  {
    path: 'login',
    element: <Login />,
  },
  {
    path: 'login-lite',
    element: <LoginLite />,
  },
  {
    path: 'logout',
    element: <Logout />,
  },
  {
    path: 'qr',
    element: <Qr />,
  },
  {
    path: 'qr-scanner-demo',
    element: <QrScanner />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];
